import config from '../store/config';
import axios from 'axios';
import MockAdapter from 'axios-mock-adapter';


let timeout = 2500;

let mock = new MockAdapter(axios, {delayResponse: timeout});

// eslint-disable-next-line no-unused-vars
let url = window.location.origin;
mock.onPost(config.apiPath + config.path.sendInfo).reply(function(info) {
    let data = JSON.parse(info.data);

    console.log(info.method.toLocaleUpperCase() +' - Запрос на url:'+ info.url);
    console.log('Параметры запроса:', data);

    let response = {"status":"OK","messages":null,"guid":"563aa166-7748-47a8-aed6-8d57b26afa06","policyNumber":"\u2116 \u0411\u041f\u0418957546"};
    //let response = {"status":"OK", "messages":null,"guid":"тест2","policyNumber":"\u2116 \u0411\u041f\u04181145636"};
    // let response ={
    //     "status":"ERROR",
    //     "messages":[
    //     {
    //         "field":"insuredPropertyAddress.index",
    //         "controlCode":"NotEmpty",
    //         "message":"Не указан индекс."
    //     }
    // ],
    //     "guid":"b322ec9d-7ba7-43c6-a0bc-e56236638d21",
    //     "policyNumber":null,
    //     "server":{
    //     "status":true
    // }
    // };
    /* let response = {
        status: 'ERROR',
        messages: [
            {
                message: 'eheheheh'
            },
            {
                message: 'huehuehue'
            },
        ],
        server: {
            status: true,
            message: ''
        }
    }; */
    // let response = {"status":"ERROR","server":{"status":true,"message":"\u041f\u0440\u0438\u043d\u043e\u0441\u0438\u043c \u0441\u0432\u043e\u0438 \u0438\u0437\u0432\u0438\u043d\u0435\u043d\u0438\u044f! \u041d\u0430 \u0441\u0435\u0440\u0432\u0435\u0440\u0435 \u0432\u0435\u0434\u0443\u0442\u0441\u044f \u0442\u0435\u0445\u043d\u0438\u0447\u0435\u0441\u043a\u0438\u0435 \u0440\u0430\u0431\u043e\u0442\u044b. \u041f\u043e\u043f\u0440\u043e\u0431\u0443\u0439\u0442\u0435 \u043e\u0431\u0440\u0430\u0442\u0438\u0442\u044c\u0441\u044f \u043a \u0441\u0435\u0440\u0432\u0438\u0441\u0443 \u043f\u043e\u0437\u0436\u0435."}};
    console.log('Ожидаемый ответ:', response);

    return [200, response];
});
mock.onPost(config.apiPath + config.path.getCode).reply(function(info) {
    let data = JSON.parse(info.data);

    console.log(info.method.toLocaleUpperCase() +' - Запрос на url:'+ info.url);
    console.log('Параметры запроса:', data);

    let response = {
        "status":"OK",
        "messages":[{"message":"text error"}],
        server: {status: true, message: "ошибка на сервере"}};
    console.log('Ожидаемый ответ:', response);
    return [200, response];
});
mock.onPost(config.apiPath + config.path.payReceive).reply(function(info) {
    let data = JSON.parse(info.data);

    console.log(info.method.toLocaleUpperCase() +' - Запрос на url:'+ info.url);
    console.log('Параметры запроса:', data);

    let response = {
        status: "OK",
        //link: '/#https://google.com',
        message: 'Нет ссылки. Проблемы с оплатой!',
        link: 'https://sandbox.payu.ru/pay/v2/?action=continue-payment-with-hosted-page&id=2Xrl83GapaKN2IW2ca_KnnGkw30'
    };
    console.log('Ожидаемый ответ:', response);

    return [200, response];
});
mock.onPost(config.apiPath + config.path.isTW).reply(function(info) {
    let data = JSON.parse(info.data);

    console.log(info.method.toLocaleUpperCase() +' - Запрос на url:'+ info.url);
    console.log('Параметры запроса:', data);

    let response = true;

    console.log('Ожидаемый ответ:', response);

    return [200, response];
});
mock.onPost(config.apiPath + config.path.getFile).reply(function(info) {
    let data = JSON.parse(info.data);

    console.log(info.method.toLocaleUpperCase() +' - Запрос на url:'+ info.url);
    console.log('Параметры запроса:', data);

    let response;
    response = {
        "link":"https://google.com"
    }
    console.log('Ожидаемый ответ:', response);

    return [200, response];
});
mock.onPost(config.apiPath + config.path.confirmCode).reply(function(info) {
    let data = JSON.parse(info.data);

    console.log(info.method.toLocaleUpperCase() +' - Запрос на url:'+ info.url);
    console.log('Параметры запроса:', data);

    let response = {};
    if (data.code === '0000') {
        console.log("OKKKKKKKK")
        response = {
            "status": "OK",
            "messages": [],
            server: { status: true, message: "OK" }
        }
    }
    else if(data.code === '1111'){
        response = {
            "status":"OK",
            "messages":[{"message":"Неправильный пароль смс."}],
            server: {status: true, message: "ошибка на сервере"}};
    }else if(data.code === '2222'){
        response = {
            "status":"OK",
            "messages":[{"message":"Неправильный пароль смс."}],
            server: {status: false, message: "ошибка на сервере"}};
    }else{
        response = {
            "timestamp":"2021-11-22T18:47:20.879+00:00",
            "status":"ERROR",
            "error":"Internal Server Error",
            "path":"/api/hab/AttemptSignPolicy",
            "messages":[
                {
                    "message":"Приносим свои извинения! На сервере ведутся технические работы. Попробуйте обратиться к сервису позже."
                }
            ],
            "server":{
                "status":false,
                "message":"Приносим свои извинения! На сервере ведутся технические работы. Попробуйте обратиться к сервису позже."
            }
        };
    }

    console.log('Ожидаемый ответ:', response);

    return [200, response];
});
